var _module_exports = "\n<div class=\"tb-uppercase\">{{ item | contactShort }}</div>";;
var path = '/tenant/tenant-card.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;